import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { BankCard } from '../../icons/BankCard';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { ScratchCard } from '../../icons/ScratchCard';
import { ButtonClassNames, GlobalRouteNames, TopUpRouteNames } from '../../../../models/Common';

interface PayMethodsProps {
  onClose: () => void;
}

export const TopUpMethods: FC<PayMethodsProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const handleLink = useCallback(
    (link: string) => {
      history.push(link);
    },
    [history],
  );
  return (
    <div className="pay-methods">
      <article className="modals__header__title">{t('modals.topUpBalance')}</article>
      <div className="pay-methods__container">
        <div className="pay-methods__container__card">
          <BankCard />
          <CustomMUIButton
            label={t('buttons.paymentCard')}
            handleClick={() => {
              handleLink(`${GlobalRouteNames.TopUpBalancePage}${TopUpRouteNames.BankCard}`);
              onClose();
            }}
            className={ButtonClassNames.SecondaryOutlined}
            isBold
          />
        </div>
        <div className="pay-methods__container__card">
          <ScratchCard />
          <CustomMUIButton
            label={t('buttons.scratchCard')}
            handleClick={() => {
              handleLink(`${GlobalRouteNames.TopUpBalancePage}${TopUpRouteNames.BankCard}`);
              onClose();
            }}
            className={ButtonClassNames.SecondaryOutlined}
            isBold
          />
        </div>
      </div>
    </div>
  );
};
